import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_DATA_LOGGER_BASE_URL}/v1`

export const getFiRejectionReasonDoughnut = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(
      `${BASE_URL}/fi-rejection/fi-rejection-doughnut`,
      {
        params: params
      }
    )
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}

export const getFiRejectionTable = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(`${BASE_URL}/fi-rejection/fi-table`, {
      params: params
    })
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}

export const getFiPartWise = async (params) => {
  console.log(params)
  try {
    const response = await axios.get(`${BASE_URL}/fi-rejection/fi-part-wise`, {
      params: params
    })
    return response
  } catch (err) {
    console.log(err)
    return err.response
  }
}
